
// Returns a new array with only newSize elements taken from the array. The return array may contain a bit less elements than newSize if newSize is not diveded by array.length
// The element with valuesToKeep are kept int he array so it can sometime overlaps newSize
// @example sampleArray([1, 2, 3, 4], 2) => [1, 3]
// @example sampleArray([1, 2, 3, 4], 2, [4]) => [1, 3, 4]
// TODO: !!! Note: this function can sometime return more element!
const sampleArray = (array, newSize, valuesToKeep= []) => {
  let newArray = []
  const jumpsCount = Math.ceil(array.length / newSize)

  for (var i = 0; i < array.length;) {
    newArray.push(array[i]);
    for (var j = 0; j < jumpsCount; j++) {
      i++;
      if (i >= array.length) break;
      if (valuesToKeep.find(([lon, lat]) => lon == array[i][0] && lat == array[i][1] )) {
        break;
      }
    }
  }

  return newArray
}

// @example splitArrayAtIndexes([1, 2, 3], [1]) =>  [[1], [2, 3]]
const splitArrayAtIndexes = (array, indexes) => {
  if (indexes.length === 0) { return [array] }
  let portions = []

  portions[0] = array.slice(0, indexes[0] + 1)

  var i = 1;
  for (i = 1; i < indexes.length; i++) {
    // We take into account the separator into the previous and the next portion
    portions[i] = array.slice(indexes[i - 1], indexes[i] + 1)
  }
  // i == indexes.length
  portions[i] = array.slice(indexes[i - 1], array.length)

  return portions
}

// @exapple getDirection(2323) => 1, getDiraction(-111) => -1

// TODO: when displaying: remove when there is not a big difference
const getDirection = (number) => number == 0 ? 0 : (number > 0 ? 1 : -1)

const getDeniveles = (elevations) => {
  var down = 0
  var up = 0

  for (var i = 1; i < elevations.length; i++) {
    const difference = elevations[i] - elevations[i - 1]

    if (difference > 0) {
      up += difference;
    } else {
      down -= difference; // difference < 0
    }
  }

  return { down: down, up: up }
}


// Simplify when there is only one less than 100m ?
const getMinimumAndMaximums = (array) => {
  // TODO: cas pour moins de 2 elements

  let minimumsAndMaximus = [array[0]]

  let currentDirection = getDirection(array[1] - array[0])

  var i = 1

  while(i < array.length) {
    while (i < array.length && (array[i] == array[i - 1] || getDirection(array[i] - array[i - 1]) == currentDirection)) {
      i++;
    }

    //if (Math.abs(array[i - 1] - minimumsAndMaximus[minimumsAndMaximus.length - 1]) > 100) {
    //  minimumsAndMaximus.push(array[i - 1])
    //}

    minimumsAndMaximus.push(array[i - 1])


    currentDirection = getDirection(array[i] - array[i - 1]);
  }

  return minimumsAndMaximus
}

const simplifyDenivele = (array) => {
  let new_array = [array[0]]



  for (var i = 1; i < array.length; i++) {
    const last_new_array_element = new_array[new_array.length - 1]

    if(Math.abs(array[i] - last_new_array_element) < 80) {

      // On ne le rajoute pas
      if (new_array.length >= 2) {
        if (last_new_array_element > new_array[new_array.length - 2] && array[i] > last_new_array_element
          || last_new_array_element < new_array[new_array.length - 2] && array[i] < last_new_array_element
        ){
          new_array[new_array.length - 1] = array[i]
        }
      }
    } else {
      new_array.push(array[i])
    }
  }

  return new_array
}

const getMinimumAndMaximumsSimplified = (array) => getMinimumAndMaximums(simplifyDenivele(array))


// from https://www.30secondsofcode.org/js/s/split-array-into-chunks/#:~:text=Split%20array%20into%20chunks%20of%20a%20given%20size&text=This%20can%20be%20calculated%20by,from()%20.
const arrayInChunk = (array, maxSize) => (
  Array.from({ length: Math.ceil(array.length / maxSize) }, (v, i) =>
    array.slice(i * maxSize, i * maxSize + maxSize)
  )
)


// je découpe en array de 348
const getElevationForPoints = async (coords, sampling) => {
  const coordsInChunk = arrayInChunk(coords, 348)

  const elevationChunk = await Promise.all(coordsInChunk.map(async (coordsPart) => {

    // I'm using the deprecated api because it seems faster than the documented api
    const response = await fetch('https://data.geopf.fr/altimetrie/1.0/calcul/alti/rest/elevation.json?resource=ign_rge_alti_par_territoires&' +
      `lon=${coordsPart.map((longLat) => longLat[0].toFixed(4)).join('|')}&lat=${coordsPart.map((longLat) => longLat[1].toFixed(4)).join('|')}`)

    const elevationDatas = (await response.json()).elevations
    return elevationDatas
  }))

  return elevationChunk.flat()
}


// @param portionsSeparators [Array<String>] . Arrau of string of format `${lon},${lat}` that delimit the portions of the path
// Si trop de points demandés pour le chemin (si minElevationPoints > environ 400) on en envoit moins mais on espere que ça soit correctement échantilloné
const getElevationsForCoords = async (coordsLongLat, portionsSeparators = [], minElevationPoints = 0) => {
  const coordsSplitSmall = sampleArray(coordsLongLat,
    minElevationPoints,
    portionsSeparators.map((portionSeparatorString) => portionSeparatorString.split(',').map(parseFloat))
  )

  const elevationDatas = await getElevationForPoints(coordsSplitSmall, Math.max(minElevationPoints, coordsSplitSmall.length) )

  const portionsSeparatorIndexesInPathArray = portionsSeparators.map((separator) => coordsLongLat.findIndex(([lon, lat]) => `${lon},${lat}` === separator) )

  const portionsSeparatorIndexesInElevationArray = portionsSeparatorIndexesInPathArray.map((positionPathArray) => Math.floor(positionPathArray * elevationDatas.length / coordsLongLat.length))

  portionsSeparatorIndexesInElevationArray.forEach((el, index) => {
    const [lon1, lat1] = coordsLongLat[portionsSeparatorIndexesInPathArray[index]]
    const {lon: lon2, lat: lat2} = elevationDatas[portionsSeparatorIndexesInElevationArray[index]]

    // It's about 100 m from the point
    if (Math.abs(lat1-lat2) > 0.001879 || Math.abs(lon1-lon2) > 0.002918) {
      window.onerror("ecart trop grand", "altitudes.js", 160)
    }
  })

  const elevationPortionsData = splitArrayAtIndexes(elevationDatas, portionsSeparatorIndexesInElevationArray)

  const tmp = {
    elevationsGlobal: elevationDatas.map(({z}) => z),
    elevationsPortions: elevationPortionsData.map((elevationPortionData) => (elevationPortionData.map(({z}) => z)))
  }

  if (tmp.elevationsPortions[0].length === 0) {
    window.onerror("no elevation in portion", "altitudes.js:getElevationsForCoords", 168);
  }

  return tmp

};

export {getElevationsForCoords, getMinimumAndMaximumsSimplified, getDeniveles}
